import { Owner, ProjectDTO } from 'cargo-chief-commons';

export const procurementPageStateKey = 'procurement-page';

export interface ProcurementState {
	activeTab: string;
	annualVolume: boolean;
	error: string;
	filters: any[];
	loading: boolean;
	projects: ProjectDTO[];
	sort: any[];
	total: number;
	userId: number;
	usersList: Owner[];
	allTabs: string[];
	userSortAndFilters: any[];
}

export const initialState: ProcurementState = {
	activeTab: 'All Lanes',
	annualVolume: false,
	error: null,
	filters: [],
	loading: true,
	projects: [],
	sort: [],
	total: 0,
	userId: null,
	usersList: [],
	allTabs: ['All Lanes'],
	userSortAndFilters: [],
};
